import React from "react";
import "../../styles/FolderWindow.css";
import closeButton from "../../assets/images/close.png";

const StreamingWindow = ({ title, embedContent, onClose }) => {
    return (
        <div className="folder-window">
            <div className="folder-header">
                <span>{title}</span>
                <button onClick={onClose} style={{ backgroundColor: "transparent", border: "none" }}>
                <img src={closeButton} alt="Close" style={{ width: "24px", height: "auto" }} />
                </button>
            </div>
            <div className="folder-content">
                {typeof embedContent === "string" ? (
                    <div dangerouslySetInnerHTML={{ __html: embedContent }} />
                ) : (
                    embedContent
                )}
            </div>
        </div>
    );
};

export default StreamingWindow;